import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../../dynamicFormBuilder/FormField';
import LocationSearchFormLayout from './LocationSearchFormLayout';
import axios from "axios";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { Button } from 'devextreme-react/button';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const LocationtSearchForm = (props) => {
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const getCarrierUrl =  "wm/TransactionManagement/GetCarrier"
    const [selectedItems, setSelectedItems] = useState([]);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const [forceRender, setForceRender] = useState(false);
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const initialFormFields = {
        Warehouse: '',
        Location: '',
        Description: '',
        Classcode: '',
    };
    const [formFields, setformFields] = useState(initialFormFields);

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
        },
        [selectedItems, setSelectedItems],
    );
    const handleFormSubmit = async (e) => {
        e.event.stopPropagation();
        props.searchData(formFields);
    };
    const handleFieldChange = useCallback((name, value) => {

    }, []);
    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
    };
    const formRefs = useRef({});
    const GetLookupData = async (name, url, accessToken, formRefs, setForceRender, forceRender) => {
        try {
          const response = await axios.get(`${window._env_.REACT_APP_APIS}/${url}`, {
            headers: {
              access_token: accessToken,
              Authorization: `Bearer ${accessToken}`
            }
          });
          const responseData = response.data;
          if (responseData.success) {
            const newOptions = responseData.lookups.map(item => ({
              id: item.rowid,
              name: item.code
            }));
            if (formRefs.current[name]) {
              formRefs.current[name].instance().option('dataSource', newOptions);
              formRefs.current[name].instance().option('valueExpr', 'id');
              formRefs.current[name].instance().option('displayExpr', 'name');
              setForceRender(!forceRender);
            }
            return newOptions;
          }
          else {
            return null;
          }
        }
        catch (error) {
          return null;
      
          } 
      };
       
    const handleSalesOrderSearchFormLoad = useCallback(() => {
        GetLookupData("R_CUSTOMER", getCustomerUrl, accessToken, formRefs, formRefs, setForceRender, forceRender);
    }, []);

    return (
        <form onSubmit={(e) => handleFormSubmit(e)}>
            <AccordionReact
                dataSource={searchpanel}
                collapsible={true}
                multiple={false}
                animationDuration={300}
                selectedItems={selectedItems}
                onSelectionChanged={e => {
                    if (e.currentTarget === e.target) {
                        selectionChanged(e, e.target);
                    }
                }}
                itemTitleRender={() => (
                    <Toolbar className="accordian-toolbar">
                        <Item location="before">
                            <div className="title">
                                <h6
                                    style={{
                                        color: window._env_.Color2
                                    }}
                                >
                                  {props.pageTitle}
                                </h6>
                            </div>
                        </Item>

                        <Item location="after">
                            <Button className="accordianButton" onClick={(e) => handleFormSubmit(e)}  text="Search" type="default" />
                        </Item>
                        <Item location="after">
                            <Button className="accordianButton" onClick={(e) => handleReset(e)}    text="Reset" />
                        </Item>
                    </Toolbar>
                )}
                itemRender={(itemProps) => (
                    <div>
                        <FormField
                            currrentUser={currentUser}
                            layoutId='2E753144-22BB-4372-8DE5-018BA51A5443'
                            layoutName='MyTestForm'
                            defaultFormSchema={LocationSearchFormLayout}
                            formFields={formFields}
                            setformFields={setformFields}
                            handleFieldValueChange={handleFieldChange}
                            DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                            formRefs={formRefs}
                            onFormLoad={handleSalesOrderSearchFormLoad}
                            noSpacingBeforeFirstRow={true}
                        />

                    </div>
                )}
                id="accordion-container" className="accordion-height"
            />
        </form>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationtSearchForm);